import { render, staticRenderFns } from "./balance_comparison.vue?vue&type=template&id=1a638d36&"
import script from "./balance_comparison.vue?vue&type=script&lang=js&"
export * from "./balance_comparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports